import '@babel/polyfill';
import '@babel/plugin-syntax-dynamic-import';
import * as conditioner from 'conditioner-core/conditioner-core.min';
import LazyLoad from "vanilla-lazyload";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import barba from '@barba/core';
import * as lenis from './modules/lenis';
import { initScrollReveal } from './modules/scrollReveal';

import { BlurScrollEffect as BlurScrollEffect1 } from './vendors/blurScrollEffect.js';

gsap.registerPlugin(ScrollTrigger);

const datalayer = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'dataLayer.ready'
    })
}

const app = () => {
    lenis.init();
    window.lazyLoadInstance = new LazyLoad({
        elements_selector: '[data-src], video',
        threshold: 50,
        callback_loaded: (img) => {
            img.classList.add('loaded');
        }
    });

    initScrollReveal();
}

const timeline = gsap.timeline();
const barbaWrap = document.querySelector('.barba-wrap');
const transitionDuration = 0.4;
const delay = (n) => new Promise(resolve => setTimeout(resolve, n));
barba.init({
    timeout: 5000,
    transitions: [{
        async leave() {
            timeline.to(barbaWrap, { opacity: '0', duration: transitionDuration });
            await delay(transitionDuration * 1000);
            this.async();
        },
        beforeEnter: ({ next }) => {
            const matches = next.html.match(/<body.+?class="([^""]*)"/i);
            document.body.setAttribute('class', matches?.[1] ?? '');
        },
        once() {
            datalayer();
            conditioner.hydrate(document.documentElement);
        }
    }]
});

// Hooks Barba.js optimisés
barba.hooks.after(() => {
    lenis.destroy();
    window.scrollTo(0, 0);
    app();
    conditioner.hydrate(document.documentElement);

    if (window.location.hash) {
        const targetElement = document.querySelector(window.location.hash);
        if (targetElement) {
            const offset = 0;
            const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({
                top: targetPosition,
                behavior: "smooth"
            });
        }
    }
});

barba.hooks.enter(() => {
    datalayer();
    timeline.to(barbaWrap, { opacity: '1', duration: transitionDuration });
});

conditioner.addPlugin({
    monitor: {
        name: 'visible',
        create: (context, element) => ({
            matches: false,
            addListener(change) {
                new IntersectionObserver((entries) => {
                    this.matches = entries.pop().isIntersecting === context;
                    change();
                }, { threshold: 0.1 }).observe(element);
            },
        }),
    },
    moduleSetName: (name) => `./modules/${name}.js`,
    moduleGetConstructor: (module) => module.default,
    moduleImport: (name) => import(/* webpackMode: "lazy" */ `${name}`),
});

app();
window.barba = barba;
window.conditioner = conditioner;